// src/services/helpContentService.js
import { apiRequest } from './api';

const HELP_CONTENT_BASE_URL = '/help-content';
const APP_SETTINGS_BASE_URL = '/app-settings';

/**
 * Help Content & App Settings Service
 * Manages Help Topics, FAQs, and Support Settings consumed by the
 * Flutter mobile app's Help / Support / Contact Support screens.
 */
export const helpContentService = {
    // ==================== HELP TOPICS ====================
    getHelpTopics: async () => {
        try {
            const response = await apiRequest.get(`${HELP_CONTENT_BASE_URL}/topics`);
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to fetch help topics');
        }
    },

    // ==================== HELP FAQS ====================
    getHelpFaqs: async () => {
        try {
            const response = await apiRequest.get(`${HELP_CONTENT_BASE_URL}/faqs`);
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to fetch help FAQs');
        }
    },

    // ==================== UPDATE HELP CONTENT (topics + faqs) ====================
    updateHelpContent: async ({ topics, faqs }) => {
        try {
            const payload = {};
            if (topics) payload.topics = topics;
            if (faqs) payload.faqs = faqs;

            const response = await apiRequest.put(`${HELP_CONTENT_BASE_URL}`, payload);
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to update help content');
        }
    },

    // ==================== APP / SUPPORT SETTINGS ====================
    getAppSettings: async () => {
        try {
            const response = await apiRequest.get(`${APP_SETTINGS_BASE_URL}`);
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to fetch app settings');
        }
    },

    updateAppSettings: async (settings) => {
        try {
            const response = await apiRequest.put(`${APP_SETTINGS_BASE_URL}`, { settings });
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.response?.data?.error || error.message || 'Failed to update app settings');
        }
    }
};

export default helpContentService;
